import { render } from "./ListeAproposPage.vue?vue&type=template&id=7b4bdb57&ts=true"
import script from "./ListeAproposPage.vue?vue&type=script&lang=ts"
export * from "./ListeAproposPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__